import {BrandColors} from "./types";
import {defaultPalette} from './defaultPalette';
import {uckPalette} from "./uckPalette";

const palettes: Record<string, BrandColors> = {
    default: defaultPalette,
    uck: uckPalette,
};

export function getPalette(clientTheme: string): BrandColors {
    return palettes[clientTheme] || palettes.default;
}